import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import styled, { createGlobalStyle } from "styled-components";
import { palette } from "../../../assets/styles/Palette";
import AtomPersonaLoader from "../../Global/components/atoms/AtomPersonaLoader";
import { Button } from "../../../assets/styles/ButtonStyle";
import PopupWrap from "../../../assets/styles/Popup";
import Markdown from "markdown-to-jsx";
import {
  ContentsWrap,
  MainContent,
  TabContent5,
  TabContent5Item,
  DropzoneStyles,
  InterviewPopup,
} from "../../../assets/styles/BusinessAnalysisStyle";
import {
  H4,
  H3,
  Body1,
  Body2,
  Body3,
  InputText,
} from "../../../assets/styles/Typography";
import {
  FormBox,
  CustomTextarea,
  RadioButton,
} from "../../../assets/styles/InputStyle";
import "react-dropzone-uploader/dist/styles.css";
import { useDynamicViewport } from "../../../assets/DynamicViewport";
import MoleculeFileUpload from "../components/molecules/MoleculeFileUpload";
import OrganismDesignConceptSelector from "../components/organisms/OrganismDesignConceptSelector";
import MoleculeAnalysisCard from "../components/molecules/MoleculeAnalysisCard";
import MoleculeCreateDisplayHeader from "../components/molecules/MoleculeCreateDisplayHeader";
import MoleculeEditableMarkdown from "../components/molecules/MoleculeEditableMarkdown";
import {
  IS_LOGGED_IN,
  AUTODISPLAY_SELECTED_DEVICE,
  CUSTOMER_ID,
} from "../../AtomStates";
import { useAtom } from "jotai";
import {
  createInfoBoardContentOnServer,
  updateInfoBoardContentOnServer,
  AutoDisplayFileAnalysisMultimodalRequest,
  AutoDisplayFileAnalysisRequest,
  AutoDisplayContentGeneratorRequest,
  getUserMemberType,
} from "../../../utils/indexedDB";

// const designConceptsData = [
//   {
//     id: "concept1",
//     name: "컨셉1",
//     description: "컨셉1",
//   },
//   {
//     id: "concept2",
//     name: "컨셉2",
//     description: "컨셉2",
//   },
//   {
//     id: "concept3",
//     name: "컨셉3",
//     description: "컨셉3",
//   },
//   {
//     id: "concept4",
//     name: "컨셉4",
//     description: "컨셉4",
//   },
//   {
//     id: "concept5",
//     name: "컨셉5",
//     description: "컨셉5",
//   },
//   {
//     id: "concept6",
//     name: "컨셉6",
//     description: "컨셉6",
//   },
//   {
//     id: "concept7",
//     name: "컨셉7",
//     description: "컨셉7",
//   },
//   {
//     id: "concept8",
//     name: "컨셉8",
//     description: "컨셉8",
//   },
//   {
//     id: "concept9",
//     name: "컨셉9",
//     description: "컨셉9",
//   },
// ];

const designConceptsData = [
  {
    id: "concept1",
    name: "컨셉1",
    description: "컨셉1",
  },
  
];

const targetAudienceOptions = [
  {
    id: "teachers",
    name: "교직원",
    icon: (
      <svg
        width="44"
        height="44"
        viewBox="0 0 44 44"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M32.8389 14.0273C33.3392 18.3607 30.5396 27.0273 23.3396 27.0273C19.0414 27.0273 16.1244 23.9388 14.5857 20.5273C13.6618 18.479 13.2348 16.3143 13.3041 14.6318"
          stroke="#666666"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M26.8402 8.52734C27.6402 12.1273 31.5069 14.694 33.3402 15.0273C33.6736 10.8607 32.1402 2.52734 23.3402 2.52734C14.5402 2.52734 13.0069 10.8607 13.3402 15.0273C14.5402 15.4273 16.1736 12.194 16.8402 11.5273C21.6402 12.3273 25.5069 10.194 26.8402 8.52734Z"
          stroke="#666666"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M18.3398 25.0273V28.0273M18.3398 28.0273L22.4379 31.0273M18.3398 28.0273C17.701 28.1385 16.9556 28.3042 16.157 28.5273M22.4379 31.0273L27.3398 28.0273M22.4379 31.0273L19.8398 37.5273M22.4379 31.0273L24.8398 37.5273M27.3398 28.0273V26.0273M27.3398 28.0273C28.0431 28.0273 28.7093 28.0671 29.3398 28.1415M19.8398 37.5273L16.157 28.5273M19.8398 37.5273C19.8398 37.5273 21.3095 41.5329 22.4379 41.5273C23.2001 41.5236 24.8398 37.5273 24.8398 37.5273M24.8398 37.5273L29.3398 28.1415M16.157 28.5273C15.6456 28.6702 15.1124 28.8367 14.5714 29.0273C10.8876 30.3257 6.83984 32.749 6.83984 36.5273V41.5273H39.3398V36.5273C38.9165 34.1285 36.6294 29.6986 30.8398 28.3964C30.3638 28.2893 29.8641 28.2034 29.3398 28.1415"
          stroke="#666666"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M16.8398 17.0273C16.8398 18.4081 17.9591 19.5273 19.3398 19.5273C20.7206 19.5273 21.8398 18.4081 21.8398 17.0273C21.8398 15.6466 20.7206 14.5273 19.3398 14.5273C17.9591 14.5273 16.8398 15.6466 16.8398 17.0273ZM16.8398 17.0273L13.8398 17.5273"
          stroke="#666666"
          strokeWidth="2"
        />
        <path
          d="M29.8398 17.0273C29.8398 18.4081 28.7206 19.5273 27.3398 19.5273C25.9591 19.5273 24.8398 18.4081 24.8398 17.0273M29.8398 17.0273C29.8398 15.6466 28.7206 14.5273 27.3398 14.5273C25.9591 14.5273 24.8398 15.6466 24.8398 17.0273M29.8398 17.0273L32.3398 17.5273M24.8398 17.0273H21.8398"
          stroke="#666666"
          strokeWidth="2"
        />
        <path
          d="M12.8398 15.0273C11.183 15.0273 9.83984 16.3705 9.83984 18.0273C9.83984 19.6842 11.183 21.0273 12.8398 21.0273C13.2625 21.0273 13.6647 20.9399 14.0295 20.7822"
          stroke="#666666"
          strokeWidth="2"
        />
        <path
          d="M33.0293 15.0273C34.6862 15.0273 36.0293 16.3705 36.0293 18.0273C36.0293 19.6842 34.6862 21.0273 33.0293 21.0273C32.6066 21.0273 32.2044 20.9399 31.8397 20.7822"
          stroke="#666666"
          strokeWidth="2"
        />
      </svg>
    ),
  },
  {
    id: "all",
    name: "전체 사용자",
    icon: (
      <svg
        width="44"
        height="44"
        viewBox="0 0 44 44"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="9.37891"
          y="5.52734"
          width="31.061"
          height="31.061"
          rx="3.40813"
          stroke="#666666"
          strokeWidth="2"
        />
        <path
          d="M20.8712 24.3296H17.2572L16.6592 26.0586H14.7482L18.0112 16.9716H20.1302L23.3932 26.0586H21.4692L20.8712 24.3296ZM20.3772 22.8736L19.0642 19.0776L17.7512 22.8736H20.3772ZM26.0428 24.6156H29.0328V26.0586H24.2228V16.9846H26.0428V24.6156ZM31.6196 24.6156H34.6096V26.0586H29.7996V16.9846H31.6196V24.6156Z"
          fill="#666666"
        />
        <path
          d="M31.1535 40.5266H27.4801H20.1332H11.317C8.0709 40.5266 5.43945 37.8951 5.43945 34.6491V25.8328V18.4859V14.8125"
          stroke="#666666"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
];

const PageCreateInfoContent = () => {
  const navigate = useNavigate();

  const [isLoggedIn] = useAtom(IS_LOGGED_IN);
  const [selectedDevice] = useAtom(AUTODISPLAY_SELECTED_DEVICE);
  // UI 상태 관리
  const [showPopupError, setShowPopupError] = useState(false);
  const [activeTab, setActiveTab] = useState(1);
  const [completedSteps, setCompletedSteps] = useState([]);
  const [businessDescription, setBusinessDescription] = useState("");
  const [contentTarget, setContentTarget] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showPopupFileSize, setShowPopupFileSize] = useState(false);
  const [toolSteps, setToolSteps] = useState(0);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [fileNames, setFileNames] = useState([]);
  const [interviewModeType, setInterviewModeType] = useState("conceptBoard");
  const [showCreditPopup, setShowCreditPopup] = useState(false);
  const [selectedDesignConcepts, setSelectedDesignConcepts] = useState([]);
  const [selectedPurposes, setSelectedPurposes] = useState({
    customerList: "",
  });
  const [isLoadingTemplate, setIsLoadingTemplate] = useState(false);
  const [showTemplateSelection, setShowTemplateSelection] = useState(false);
  const [showPreviewPopup, setShowPreviewPopup] = useState(false);
  const [autoDisplayFileAnalysis, setAutoDisplayFileAnalysis] = useState(null);
  const [timeStamp, setTimeStamp] = useState(null);
  const [customerId, setCustomerId] = useAtom(CUSTOMER_ID);

  const [
    autoDisplayContentGeneratorMarkdown,
    setAutoDisplayContentGeneratorMarkdown,
  ] = useState([]);
  const [
    autoDisplayContentGeneratorTitle,
    setAutoDisplayContentGeneratorTitle,
  ] = useState([]);
  const [contentsPurpose, setContentsPurpose] = useState(null);

  const [selectedTargetAudience, setSelectedTargetAudience] = useState(null);
  const [isEditingMarkdown, setIsEditingMarkdown] = useState(false);

  useDynamicViewport("width=1280");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const checkMemberType = async () => {
      const accessToken = sessionStorage.getItem("accessToken");
      const userMemberType = await getUserMemberType(accessToken);
      const lastUrl = sessionStorage.getItem("lastUrl");

      if (
        (lastUrl === "/CreateApiContent" || lastUrl === "/ApiDashBoard") &&
        userMemberType.member_type === 99
      ) {
        navigate("/Admin");
      }

      if (userMemberType.member_type === 11) {
        navigate("/DashBoard");
      } else if (userMemberType.member_type === 12) {
        navigate("/CustomerManage");
      } else if (userMemberType.member_type === 21) {
        navigate("/ApiDashBoard");
      } else if (userMemberType.member_type === 22) {
        navigate("/CustomerManage");
      }
    };

    checkMemberType();
  }, []);

  const handleNextStep = (currentStep) => {
    setCompletedSteps([...completedSteps, currentStep]);
    setActiveTab(currentStep + 1);
    setShowPopupError(false);
  };

  const abortControllerRef = useRef(null);

  const handleSubmitConcept = async () => {
    // 이미 완료된 경우 2단계로 이동 (기존 3단계)
    if (autoDisplayFileAnalysis && autoDisplayContentGeneratorMarkdown.length > 0) {
      setActiveTab(2);
      return;
    }
    
    abortControllerRef.current = new AbortController();
    const signal = abortControllerRef.current.signal;
    const timeStamp = new Date().getTime();
    setTimeStamp(timeStamp);
    setToolSteps(2);
    setIsLoading(true);
    
    // 로딩 화면을 보여주기 위해 2단계로 이동 (completedSteps에 1 추가)
    setCompletedSteps([1]);
    setActiveTab(2);

    try {
      let analysisResponse;
      let fileAnalysis;

      // 1단계: 분석 API 호출
      if (interviewModeType === "conceptBoard") {
        // 파일 업로드를 통한 분석
        const analysisData = {
          display_id: selectedDevice._id,
          files: uploadedFiles,
          time_stamp: String(timeStamp),
        };

        setFileNames(uploadedFiles.map((file) => file.name));

        let retryCount = 0;
        const maxRetries = 5;
        while (retryCount < maxRetries) {
          try {
            analysisResponse = await AutoDisplayFileAnalysisMultimodalRequest(
              analysisData,
              isLoggedIn,
              signal
            );

            if (
              analysisResponse &&
              analysisResponse.response &&
              analysisResponse.response.auto_display_file_analysis_multimodal &&
              analysisResponse.response.auto_display_file_analysis_multimodal.title &&
              analysisResponse.response.auto_display_file_analysis_multimodal.status &&
              analysisResponse.response.auto_display_file_analysis_multimodal.detail &&
              analysisResponse.response.auto_display_file_analysis_multimodal.message
            ) {
              fileAnalysis = analysisResponse.response.auto_display_file_analysis_multimodal;
              setAutoDisplayFileAnalysis(fileAnalysis);
              break; // 올바른 응답 형식이면 루프 종료
            }

            retryCount++;
          } catch (error) {
            console.error(`Retry ${retryCount + 1} failed:`, error);
            retryCount++;
            if (retryCount >= maxRetries) throw error;
          }
        }

        if (retryCount >= maxRetries) {
          throw new Error("콘텐츠 분석에 실패했습니다. 다시 시도해주세요.");
        }
      } else {
        // 텍스트만으로 분석
        const analysisData = {
          type: "auto_display_file_analysis",
          input_text: businessDescription,
        };

        let retryCount = 0;
        const maxRetries = 5;

        while (retryCount < maxRetries) {
          try {
            analysisResponse = await AutoDisplayFileAnalysisRequest(analysisData, isLoggedIn);

            if (
              analysisResponse &&
              analysisResponse.response &&
              analysisResponse.response.auto_display_file_analysis &&
              analysisResponse.response.auto_display_file_analysis.title &&
              analysisResponse.response.auto_display_file_analysis.status &&
              analysisResponse.response.auto_display_file_analysis.detail &&
              analysisResponse.response.auto_display_file_analysis.message
            ) {
              fileAnalysis = analysisResponse.response.auto_display_file_analysis;
              setAutoDisplayFileAnalysis(fileAnalysis);
              break; // 올바른 응답 형식이면 루프 종료
            }

            retryCount++;
          } catch (error) {
            console.error(`Retry ${retryCount + 1} failed:`, error);
            retryCount++;
            if (retryCount >= maxRetries) throw error;
          }
        }

        if (retryCount >= maxRetries) {
          throw new Error("텍스트 분석에 실패했습니다. 다시 시도해주세요.");
        }
      }

      // 2단계: 분석 결과를 받은 후 콘텐츠 생성 API 호출
      let contentData;
      if (interviewModeType === "conceptBoard") {
        // 파일 업로드 모드 - 파일과 함께 전송
        contentData = {
          type: "ad_info_content_multimodal", // 필수
          upload_files: uploadedFiles.map((file, index) => ({
            id: "file_" + timeStamp + "_" + (index + 1),
            name: file.name,
          })),
          display_info: {
            width: selectedDevice?.deviceSpec?.deviceWidth || "1920",
            height: selectedDevice?.deviceSpec?.deviceHeight || "1080",
            resolution: selectedDevice?.deviceSpec?.deviceDPI || "Full HD",
          },
          info_summary: {
            title: fileAnalysis?.title || "",
            source: fileAnalysis?.source || "",
            message: fileAnalysis?.message || "",
            detail: fileAnalysis?.detail || "",
          },
          content_target: contentTarget || "전체 사용자",
        };
      } else if (interviewModeType === "explanation") {
        // 텍스트 입력 모드 - 텍스트만 전송
        contentData = {
          type: "ad_info_content_generator", // 필수
          input_text: businessDescription,
          display_info: {
            width: selectedDevice?.deviceSpec?.deviceWidth || "1920",
            height: selectedDevice?.deviceSpec?.deviceHeight || "1080",
            resolution: selectedDevice?.deviceSpec?.deviceDPI || "Full HD",
          },
          info_summary: {
            title: fileAnalysis?.title || "",
            source: fileAnalysis?.source || "",
            message: fileAnalysis?.message || "",
            detail: fileAnalysis?.detail || "",
          },
          content_target: contentTarget || "전체 사용자",
        };
      }

      // 콘텐츠 생성 API 호출
      let retryCount = 0;
      const maxRetries = 10;
      let allResponsesMarkdown = [];
      let allResponsesTitle = [];

      while (retryCount < maxRetries) {
        try {
          const contentResponse = await AutoDisplayContentGeneratorRequest(
            contentData,
            isLoggedIn
          );

          if (
            contentResponse &&
            contentResponse.response &&
            contentResponse.response.ad_info_content_generator
          ) {
            allResponsesMarkdown.push(
              contentResponse.response.ad_info_content_generator.sections
                .section_first
            );
            allResponsesMarkdown.push(
              contentResponse.response.ad_info_content_generator.sections
                .section_second
            );
            allResponsesTitle.push(
              contentResponse.response.ad_info_content_generator.title
            );

            break; // 올바른 응답 형식이면 루프 종료
          }

          retryCount++;
        } catch (error) {
          console.error(`Retry ${retryCount + 1} failed:`, error);
          retryCount++;
          if (retryCount >= maxRetries) throw error;
        }
      }

      if (retryCount >= maxRetries) {
        throw new Error("콘텐츠 생성에 실패했습니다. 다시 시도해주세요.");
      }

      setAutoDisplayContentGeneratorMarkdown(allResponsesMarkdown);
      setAutoDisplayContentGeneratorTitle(allResponsesTitle);
      setToolSteps(3);
      
      // 1단계와 2단계를 모두 완료 처리 (기존 3단계가 2단계로 변경됨)
      setCompletedSteps([1, 2, 3]);
      // activeTab은 이미 2로 설정되어 있음
      
      // 콘텐츠 생성 완료 후 바로 디자인 생성 시작
      setIsLoadingTemplate(true);
      
      // 디자인 생성 API 호출 (실제 API 호출 로직이 있다면 여기에 추가)
      // 현재는 setTimeout으로 시뮬레이션하지만, 실제 API 호출로 변경 필요
      setTimeout(() => {
        setShowTemplateSelection(true);
        setIsLoadingTemplate(false);
      }, 5000);
      
    } catch (error) {
      console.error("콘텐츠 생성 중 오류 발생:", error);
      setShowPopupError(true);
      setIsLoadingTemplate(false);
    } finally {
      setIsLoading(false);
    }
  };

  const handleTargetAudienceSelect = (audienceId) => {
    if (completedSteps.includes(2)) return;
    setSelectedTargetAudience(audienceId);
    const selectedOption = targetAudienceOptions.find(
      (option) => option.id === audienceId
    );
    setContentTarget(selectedOption?.name || "");
  };

  const handleSubmitPurpose = async (isRegenerate = false) => {
    if (autoDisplayContentGeneratorMarkdown.length > 0 && !isRegenerate) {
      handleNextStep(2);
      return;
    }
    handleNextStep(2);
    setIsLoading(true);

    try {
      let data;
      let allResponsesMarkdown = [];
      let allResponsesTitle = [];
      if (
        interviewModeType === "conceptBoard"
      ) {
        // 파일 업로드 모드 - 파일과 함께 전송
        data = {
          type: "ad_info_content_multimodal", // 필수
          upload_files: uploadedFiles.map((file, index) => ({
            id: "file_" + timeStamp + "_" + (index + 1),
            name: file.name,
          })),
          display_info: {
            width: selectedDevice?.deviceSpec?.deviceWidth || "1920",
            height: selectedDevice?.deviceSpec?.deviceHeight || "1080",
            resolution: selectedDevice?.deviceSpec?.deviceDPI || "Full HD",
          },
          info_summary: {
            title: autoDisplayFileAnalysis?.title || "",
            source: autoDisplayFileAnalysis?.source || "",
            message: autoDisplayFileAnalysis?.message || "",
            detail: autoDisplayFileAnalysis?.detail || "",
          },
          content_target: contentTarget,
        };
      } else if (interviewModeType === "explanation") {
        // 텍스트 입력 모드 - 텍스트만 전송
        data = {
          type: "ad_info_content_generator", // 필수
          input_text: businessDescription,
          display_info: {
            width: selectedDevice?.deviceSpec?.deviceWidth || "1920",
            height: selectedDevice?.deviceSpec?.deviceHeight || "1080",
            resolution: selectedDevice?.deviceSpec?.deviceDPI || "Full HD",
          },
          info_summary: {
            title: autoDisplayFileAnalysis?.title || "",
            source: autoDisplayFileAnalysis?.source || "",
            message: autoDisplayFileAnalysis?.message || "",
            detail: autoDisplayFileAnalysis?.detail || "",
          },
          content_target: contentTarget,
        };
      }

      let retryCount = 0;
      const maxRetries = 10;

      while (retryCount < maxRetries) {
        try {
          let response = await AutoDisplayContentGeneratorRequest(
            data,
            isLoggedIn
          );

          if (
            response &&
            response.response &&
            response.response.ad_info_content_generator
          ) {
            allResponsesMarkdown.push(
              response.response.ad_info_content_generator.sections
                .section_first
            );
            allResponsesMarkdown.push(
              response.response.ad_info_content_generator.sections
                .section_second
            );
            allResponsesTitle.push(
              response.response.ad_info_content_generator.title
            );

            break; // 올바른 응답 형식이면 루프 종료
          }

          retryCount++;
        } catch (error) {
          console.error(`Retry ${retryCount + 1} failed:`, error);
          retryCount++;
          if (retryCount >= maxRetries) throw error;
        }
      }

      if (retryCount >= maxRetries) {
        throw new Error("텍스트 분석에 실패했습니다. 다시 시도해주세요.");
      }

      setAutoDisplayContentGeneratorMarkdown(allResponsesMarkdown);
      setAutoDisplayContentGeneratorTitle(allResponsesTitle);

      setToolSteps(3);
      setCompletedSteps((prev) => [...prev, 3]);
    } catch (error) {
      console.error("콘텐츠 분석 중 오류 발생:", error);
      setShowPopupError(true);
    } finally {
      setIsLoading(false);
    }
  };

  const handleChangeStatus = ({ meta, file, remove }, status) => {
    const maxSize = 20 * 1024 * 1024; // 20MB
    if (file.size > maxSize && status !== "removed") {
      setShowPopupFileSize(true);
      remove();
      return;
    }

    if (status === "done" || status === "preparing" || status === "uploading") {
      setUploadedFiles((prev) => {
        if (!prev.find((f) => f.name === file.name)) {
          setFileNames((prev) => [...prev, file.name]);
          return [...prev, file];
        }
        return prev;
      });
    } else if (status === "removed") {
      setUploadedFiles((prev) => prev.filter((f) => f.name !== file.name));
      setFileNames((prev) => prev.filter((name) => name !== file.name));
    }

    const size = file.size;
    const sizeStr =
      size > 1024 * 1024
        ? `${(size / (1024 * 1024)).toFixed(1)}MB`
        : `${(size / 1024).toFixed(1)}KB`;

    setTimeout(() => {
      const containers = document.querySelectorAll(".dzu-previewContainer");
      containers.forEach((container) => {
        if (!container.dataset.filename) {
          container.dataset.filename = file.name;
          container.dataset.size = sizeStr;

          if (file.type.startsWith("image/")) {
            if (!container.querySelector(".dzu-previewFileName")) {
              const nameSpan = document.createElement("span");
              nameSpan.className = "dzu-previewFileName";
              nameSpan.textContent = `${file.name}, ${sizeStr}`;

              if (container.firstChild) {
                container.insertBefore(nameSpan, container.firstChild);
              } else {
                container.appendChild(nameSpan);
              }
            }
          }
        }
      });
    }, 0);
  };

  const handleDesignConceptSelect = (conceptId) => {
    // 기존 4단계(현재 3단계)가 완료된 후에는 디자인 선택을 변경할 수 없음
    if (completedSteps.includes(4)) {
      return;
    }

    setSelectedDesignConcepts((prev) => {
      if (prev.includes(conceptId)) {
        return [];
      } else {
        return [conceptId];
      }
    });
  };

  const handleSaveMarkdown = (data) => {
    // editableTitle이 true인 경우 data는 { markdown, title } 객체
    // false인 경우 data는 markdown 배열
    if (data && typeof data === 'object' && !Array.isArray(data)) {
      setAutoDisplayContentGeneratorMarkdown(data.markdown || ["", ""]);
      if (data.title && Array.isArray(data.title)) {
        setAutoDisplayContentGeneratorTitle([data.title]);
      }
    } else {
      setAutoDisplayContentGeneratorMarkdown(data || ["", ""]);
    }
  };

  const handleDisplayConversion = async () => {
    // 기존 4단계(현재 3단계)가 완료된 후에는 디스플레이 변환을 다시 실행할 수 없음
    if (completedSteps.includes(4)) {
      return;
    }
    
    // 콘텐츠 제목이 비어있으면 진행하지 않음
    if (!autoDisplayFileAnalysis?.title || autoDisplayFileAnalysis.title.trim() === '') {
      // 에러 메시지 표시 또는 사용자에게 알림
      return;
    }

    setIsLoadingTemplate(true);

    setTimeout(() => {
      setShowTemplateSelection(true);
      setIsLoadingTemplate(false);
    }, 5000);
  };

  const handleConfirmContent = async () => {
    // 기존 4단계(현재 3단계)가 이미 완료된 경우 바로 3단계로 이동
    if (completedSteps.includes(4)) {
      setActiveTab(3);
      return;
    }
    
    handleNextStep(2); // 기존 3단계가 2단계로 변경됨
    setToolSteps(4);
    // 기존 4단계(현재 3단계)도 즉시 완료 처리하여 화면실행 탭 활성화
    setTimeout(() => {
      setCompletedSteps(prev => [...prev, 4]);
    }, 100);

    try {
      const createViewId = await createInfoBoardContentOnServer(isLoggedIn);

      let finalMarkdown = null;
      let finalTitle = null;
      let finalJson = null;

      finalMarkdown = autoDisplayContentGeneratorMarkdown;
      finalTitle = autoDisplayContentGeneratorTitle[0];

      // 데이터를 조합하여 contentData 객체 생성
      const now = new Date();
      const contentData = {
        viewDevice: {
          _id: selectedDevice?._id || "",
          deviceTitle: selectedDevice?.deviceTitle || "",
          deviceDPI: selectedDevice?.deviceSpec?.deviceDPI || "",
          deviceInch: selectedDevice?.deviceSpec?.deviceInch || "",
          deviceCm: selectedDevice?.deviceSpec?.deviceCm || "",
          deviceWidth: selectedDevice?.deviceSpec?.deviceWidth || "",
          deviceHeight: selectedDevice?.deviceSpec?.deviceHeight || "",
        },
        uploadFileData: uploadedFiles.map((file, index) => ({
          id: "file_" + timeStamp + "_" + (index + 1),
          name: file.name,
        })),
        textData: businessDescription,
        dataAnalysis: {
          title: autoDisplayFileAnalysis?.title || "",
          source: autoDisplayFileAnalysis?.source || "",
          message: autoDisplayFileAnalysis?.message || "",
          detail: autoDisplayFileAnalysis?.detail || "",
        },
        designConcept: selectedDesignConcepts[0],
        contentsType: "general",
        contentsTarget: contentTarget,
        contentGeneratorMarkdown: finalMarkdown,
        contentGeneratorJson: null,
        contentGeneratorTitle: finalTitle,
        createDate: now.toLocaleString("ko-KR", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: true,
        }),
        createTimestamp: now.getTime(),
      };
      if (customerId !== "") {
        contentData.customer = customerId;
      }
      setContentsPurpose(selectedPurposes.customerList);
      console.log(
        "selectedPurposes.customerList",
        selectedPurposes.customerList
      );
      await updateInfoBoardContentOnServer(createViewId, contentData);

      // setAutoDisplaySelectedContent(createViewId);
      // navigate("/DashBoard");
    } catch (error) {
      console.error("콘텐츠 확인 또는 업데이트 실패:", error);
    }
  };

  useEffect(() => {
    // 새로고침 감지 함수
    const detectRefresh = () => {
      // 현재 URL 확인
      const currentUrl = window.location.href;
      if (currentUrl.toLowerCase().includes("createinfocontent")) {
        // 세션 스토리지에서 마지막 URL 가져오기
        const lastUrl = sessionStorage.getItem("lastUrl");

        // 마지막 URL이 현재 URL과 같으면 새로고침
        if (lastUrl && lastUrl === currentUrl) {
          // if (customerId !== "") {
          //   navigate("/EduboardManage");
          // } else {
            navigate("/InfoContentManageDashBoard");
          // }
          return true;
        }

        // 현재 URL 저장
        sessionStorage.setItem("lastUrl", currentUrl);
      }

      return false;
    };

    // F5 키 또는 Ctrl+R 감지
    const handleKeyDown = (event) => {
      if (
        (event.key === "r" && (event.metaKey || event.ctrlKey)) ||
        event.key === "F5"
      ) {
        // F5 키 코드
        event.preventDefault();

        // if (customerId !== "") {
        //   navigate("/EduboardManage");
        // } else {
          navigate("/InfoContentManageDashBoard");
        // }
      }
    };

    // 함수 실행
    detectRefresh();

    // 이벤트 리스너 등록
    window.addEventListener("keydown", handleKeyDown);

    // 컴포넌트 언마운트 시 이벤트 리스너 제거
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [navigate]);

  const handleGoBack = async () => {
    try {
      // 현재 저장된 데이터를 가져온다
      let currentData;
      const currentViewId = customerId;

      // currentData = await getViewDetailOnServer(currentViewId, isLoggedIn);

      // console.log("currentData", currentData);

      if (
        currentData &&
        currentData.activateCode &&
        Array.isArray(currentData.activateCode)
      ) {
        // activateCode 배열에서 state와 activeState가 1인 항목들의 updateState를 1로 변경
        const updatedActivateCode = currentData.activateCode.map((item) => {
          if (item.state === 1 && item.activeState === 1) {
            return {
              ...item,
              updateState: 1,
            };
          }
          return item;
        });

        // 기존 데이터 유지하면서 activateCode만 업데이트
        const updateData = {
          ...currentData,
          activateCode: updatedActivateCode,
        };

        // 데이터 타입에 따라 적절한 업데이트 함수 호출
        await updateInfoBoardContentOnServer(currentViewId, updateData);

        // console.log("activateCode 업데이트 완료:", updatedActivateCode);
      }

      // 완료 후 페이지 이동
      navigate("/InfoContentManageDashBoard");
    } catch (error) {
      console.error("돌아가기 처리 중 오류 발생:", error);
      // 오류가 발생해도 페이지는 이동
      navigate("/InfoContentManageDashBoard");
    }
  };


  return (
    <>
      <DropzoneStyles />
      <ContentsWrap>
        {/* <OrganismIncNavigation /> */}
        {/* <MoleculeHeader /> */}
        <MoleculeCreateDisplayHeader
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          completedSteps={completedSteps}
          isLoading={isLoading}
          onSubmitConcept={handleSubmitConcept}
          onSubmitReport={handleSubmitPurpose}
          onDisplayConversion={handleDisplayConversion}
          hasContentDraft={showTemplateSelection}
          onConfirmContent={handleConfirmContent}
          isLoadingTemplate={isLoadingTemplate}
          // 1단계에서 파일 업로드나 텍스트 입력이 있는지 확인
          canProceedFromStep1={
            activeTab === 1
              ? (interviewModeType === "conceptBoard" &&
                  fileNames &&
                  fileNames.length > 0) ||
                (interviewModeType === "explanation" &&
                  businessDescription &&
                  businessDescription.trim().length > 0)
              : // || (interviewModeType === "article" && selectedMessage)
                true
          }
          // 2단계에서 모든 필수 항목이 선택되었는지 확인
          canProceedFromStep2={
           true
          }
          canProceedFromStep3={
            isEditingMarkdown
              ? false // 편집 중일 때는 다음 버튼 비활성화
              : activeTab === 2 && showTemplateSelection
              ? selectedDesignConcepts.length > 0
              : activeTab === 2
              ? autoDisplayFileAnalysis?.title && 
                autoDisplayFileAnalysis.title.trim() !== ''
              : true
          }
        />

        <MainContent Wide1030>
          <DesignAnalysisWrap>
            {activeTab === 1 && (
              <TabContent5>
                <>
                  <div className="content">
                    <TabContent5Item required>
                      <div style={{ height: "20px" }}></div>
                      <H3
                        color="gray800"
                        style={{ textAlign: "left" }}
                      >
                        AI 콘텐츠 생성을 위한 자료를 업로드해주세요{" "}
                      </H3>
                      {/* <InfoBox>
                        <InfoContent>
                          <Body2
                            color="black"
                            style={{
                              fontWeight: "600",
                              textAlign: "left",
                              fontSize: "20px",
                            }}
                          >
                            {selectedDevice?.deviceTitle}
                          </Body2>
                          <DeviceInfoBox>
                            <Body3 color="gray600">
                              {selectedDevice?.deviceSpec.deviceDPI}
                            </Body3>
                            <Body3 color="gray600">
                              {selectedDevice?.deviceSpec.deviceInch}
                            </Body3>
                            <Body3 color="gray600">
                              {selectedDevice?.deviceSpec.deviceWidthMM}x
                              {selectedDevice?.deviceSpec.deviceHeightMM} (mm)
                            </Body3>
                          </DeviceInfoBox>
                        </InfoContent>
                      </InfoBox> */}
                    </TabContent5Item>
                  </div>

                  <div className="content">
                    <TabContent5Item required>
                      <InterviewModeSelection style={{ marginBottom: "-5px" }}>
                        <Button
                          Medium
                          Outline
                          style={{
                            backgroundColor:
                              interviewModeType === "conceptBoard"
                                ? "#F7F8FA"
                                : "transparent",
                            borderColor:
                              interviewModeType === "conceptBoard"
                                ? "#E0E4EB"
                                : "#E0E4EB",
                          }}
                          onClick={() => {
                            if (toolSteps >= 1) return;
                            setInterviewModeType("conceptBoard");
                          }}
                          disabled={toolSteps >= 1}
                        >
                          <InputText color="gray700">파일 업로드</InputText>
                        </Button>

                        <Button
                          Medium
                          Outline
                          style={{
                            backgroundColor:
                              interviewModeType === "explanation"
                                ? "#F7F8FA"
                                : "transparent",
                            borderColor:
                              interviewModeType === "explanation"
                                ? "#E0E4EB"
                                : "#E0E4EB",
                          }}
                          onClick={() => {
                            if (toolSteps >= 1) return;
                            setInterviewModeType("explanation");
                            // 텍스트로 작성 모드로 전환할 때 업로드된 파일들 삭제
                            setUploadedFiles([]);
                            setFileNames([]);
                          }}
                          disabled={toolSteps >= 1}
                        >
                          <InputText color="gray700">텍스트로 작성</InputText>
                        </Button>
                      </InterviewModeSelection>

                      {interviewModeType === "conceptBoard" && (
                        <div className="content" style={{ marginTop: "5px" }}>
                          <MoleculeFileUpload
                            fileNames={fileNames ?? []}
                            handleChangeStatus={handleChangeStatus}
                            toolSteps={toolSteps}
                          />
                        </div>
                      )}
                    </TabContent5Item>

                    {interviewModeType === "explanation" && (
                      <>
                        <FormBox Large style={{ marginTop: "-20px" }}>
                          <CustomTextarea
                            Edit
                            rows={6}
                            placeholder="텍스트를 입력해주세요."
                            value={businessDescription}
                            onChange={(e) =>
                              setBusinessDescription(e.target.value)
                            }
                            status="valid"
                            disabled={toolSteps >= 1}
                          />
                        </FormBox>
                      </>
                    )}
                  </div>
                </>
              </TabContent5>
            )}

            {/* 기존 2단계 화면 주석처리 - 이제 1단계에서 바로 2단계(기존 3단계)로 이동 */}
            {/* {activeTab === 2 && completedSteps.includes(1) && (
              <TabContent5>
                {isLoading ? (
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      minHeight: "200px",
                      alignItems: "center",
                    }}
                  >
                    <AtomPersonaLoader message="콘텐츠 핵심 내용을 AI로 분석하고 있어요" />
                    <div style={{ height: "520px" }}></div>
                  </div>
                ) : (
                  <>
                    <div className="content">
                      <TabContent5Item required>
                        <div style={{ height: "20px" }}></div>
                        <H3
                          color="gray800"
                          style={{ textAlign: "left", marginBottom: "-12px" }}
                        >
                          콘텐츠 주요 내용  ​{" "}
                        </H3>
                        <ContentAnalysisSection>
                          <MoleculeAnalysisCard
                            values={{
                              analysisData: autoDisplayFileAnalysis,
                            }}
                            textData={businessDescription.length > 0}
                          />

                          <ContentOptionsSection>
                            <H3
                              color="gray800"
                              style={{ textAlign: "left", marginTop: "0px" }}
                            >
                            </H3>

                            <TabContent5Item>
                              <TargetAudienceRadioContainer>
                                <TargetAudienceSection>
                                </TargetAudienceSection>
                              </TargetAudienceRadioContainer>
                            </TabContent5Item>
                          </ContentOptionsSection>
                        </ContentAnalysisSection>
                      </TabContent5Item>
                    </div>
                  </>
                )}
              </TabContent5>
            )} */}

            {activeTab === 2 &&
              (completedSteps.includes(1) || completedSteps.includes(3)) && (
                <TabContent5>
                  {isLoading ? (
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        minHeight: "200px",
                        alignItems: "center",
                      }}
                    >
                      <AtomPersonaLoader message="콘텐츠 핵심 내용을 AI로 분석하고 있어요" />
                      <div style={{ height: "520px" }}></div> {/* 간격용 div */}
                    </div>
                  ) : (
                    <>
                      <div className="content">
                        <TabContent5Item required>
                          <div style={{ height: "20px" }}></div>{" "}
                          {/* 간격용 div */}
                          <H3
                            color="gray800"
                            style={{ textAlign: "left", marginBottom: "-12px" }}
                          >
                            콘텐츠 주요 내용 {" "}
                          </H3>
                          <ContentAnalysisSection>
                            <MoleculeAnalysisCard
                              showButton={false}
                              type="template"
                              onButtonClick={() => {
                                setShowPreviewPopup(true);
                              }}
                              values={{
                                deviceInfo: `${selectedDevice?.deviceTitle} (${selectedDevice?.deviceSpec.deviceInch} / ${selectedDevice?.deviceSpec.deviceWidth}x${selectedDevice?.deviceSpec.deviceHeight} (mm))`,
                                analysisData: autoDisplayFileAnalysis,
                                contentPurpose: selectedPurposes.customerList,
                                designConcept: selectedDesignConcepts,
                              }}
                            />

                            {isLoadingTemplate ? (
                              <ContentOptionsSection>
                                <TabContent5Item>
                                  <ContentInputSection>
                                    <H3
                                      color="gray800"
                                      style={{ textAlign: "left" }}
                                    >
                                      콘텐츠 내용과 대상이 잘 맞는지
                                      확인해주세요.​{" "}
                                    </H3>
                                    <InputGroup>
                                      <Label>콘텐츠 제목</Label>
                                      <FormBox Large>
                                        <CustomTextarea
                                          Edit
                                          rows={1}
                                          placeholder="콘텐츠 리스트에서 쉽게 알아볼 수 있도록 작성해주세요"
                                          value={
                                            autoDisplayFileAnalysis?.title || ""
                                          }
                                          onChange={(e) => {
                                            setAutoDisplayFileAnalysis(
                                              (prev) => ({
                                                ...prev,
                                                title: e.target.value,
                                              })
                                            );
                                          }}
                                          status="valid"
                                          maxLength={50}
                                        />
                                      </FormBox>
                                    </InputGroup>
                                  </ContentInputSection>

                                  <div
                                    className="title"
                                    style={{ marginTop: "0px" }}
                                  >
                                    <Body1 color="gray700">
                                      디스플레이 콘텐츠 내용{" "}
                                    </Body1>
                                  </div>

                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: "16px",
                                    }}
                                  >
                                    <MoleculeEditableMarkdown
                                      markdown={autoDisplayContentGeneratorMarkdown}
                                      title={autoDisplayContentGeneratorTitle[0] || []}
                                      onSave={handleSaveMarkdown}
                                      onRegenerate={() => handleSubmitPurpose(true)}
                                      onEditingChange={setIsEditingMarkdown}
                                      maxChars={300}
                                      showRegenerateButton={true}
                                      editableTitle={true}
                                    />
                                  </div>

                                  {/* 디자인 생성 로딩 */}
                                  <div
                                    style={{
                                      width: "100%",
                                      display: "flex",
                                      justifyContent: "center",
                                      minHeight: "200px",
                                      alignItems: "center",
                                      marginTop: "32px",
                                    }}
                                  >
                                    <AtomPersonaLoader
                                      message={
                                        <>
                                          <span>디자인을 생성 중입니다</span>
                                          <span
                                            style={{
                                              fontSize: "14px",
                                              fontWeight: "400",
                                              color: palette.gray500,
                                            }}
                                          >
                                          </span>
                                        </>
                                      }
                                    />
                                  </div>
                                </TabContent5Item>
                              </ContentOptionsSection>
                            ) : (
                              <ContentOptionsSection>
                                <TabContent5Item>
                                  <ContentInputSection>
                                    <H3
                                      color="gray800"
                                      style={{ textAlign: "left" }}
                                    >
                                      콘텐츠 내용과 대상이 잘 맞는지
                                      확인해주세요.​{" "}
                                    </H3>
                                    <InputGroup>
                                      <Label>콘텐츠 제목</Label>
                                      <FormBox Large>
                                        <CustomTextarea
                                          Edit
                                          rows={1}
                                          placeholder="콘텐츠 리스트에서 쉽게 알아볼 수 있도록 작성해주세요"
                                          value={
                                            autoDisplayFileAnalysis?.title || ""
                                          }
                                          onChange={(e) => {
                                            setAutoDisplayFileAnalysis(
                                              (prev) => ({
                                                ...prev,
                                                title: e.target.value,
                                              })
                                            );
                                          }}
                                          status="valid"
                                          maxLength={50}
                                        />
                                      </FormBox>
                                    </InputGroup>
                                  </ContentInputSection>

                                  <div
                                    className="title"
                                    style={{ marginTop: "0px" }}
                                  >
                                    <Body1 color="gray700">
                                      디스플레이 콘텐츠 내용{" "}
                                    </Body1>
                                  </div>

                                  {/* 선택된 디자인 컨셉별로 콘텐츠 박스 생성 */}
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: "16px",
                                    }}
                                  >
                                    <MoleculeEditableMarkdown
                                      markdown={autoDisplayContentGeneratorMarkdown}
                                      title={autoDisplayContentGeneratorTitle[0] || []}
                                      onSave={handleSaveMarkdown}
                                      onRegenerate={() => handleSubmitPurpose(true)}
                                      onEditingChange={setIsEditingMarkdown}
                                      maxChars={300}
                                      showRegenerateButton={true}
                                      editableTitle={true}
                                    />
                                  </div>

                                  {/* 디자인 테마 선택 부분 - showTemplateSelection이 true일 때만 표시 */}
                                  {showTemplateSelection && (
                                    <>
                                      <div
                                        className="title"
                                        style={{ marginTop: "32px", marginBottom: "16px" }}
                                      >
                                        <H3
                                          color="gray800"
                                          style={{ textAlign: "left" }}
                                        >
                                          아래에서 디자인 테마를 선택해주세요{" "}
                                        </H3>
                                      </div>
                                      <OrganismDesignConceptSelector
                                        concepts={designConceptsData}
                                        selectedConcepts={selectedDesignConcepts}
                                        onSelect={handleDesignConceptSelect}
                                        disabled={completedSteps.includes(4)} // 기존 4단계(현재 3단계)
                                        titleData={
                                          autoDisplayContentGeneratorTitle[0]
                                        }
                                        markdownData={
                                          autoDisplayContentGeneratorMarkdown
                                        }
                                      />
                                    </>
                                  )}
                                </TabContent5Item>
                              </ContentOptionsSection>
                            )}
                          </ContentAnalysisSection>
                        </TabContent5Item>
                      </div>
                    </>
                  )}
                </TabContent5>
              )}

            {activeTab === 3 &&
              (completedSteps.includes(3) || completedSteps.includes(4)) && (
                <TabContent5>
                  {isLoading ? (
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        minHeight: "200px",
                        alignItems: "center",
                      }}
                    >
                      <AtomPersonaLoader message="콘텐츠 핵심 내용을 AI로 분석하고 있어요" />
                    </div>
                  ) : (
                    <>
                      <div className="content">
                        <TabContent5Item required>
                          <H3
                            color="gray800"
                            style={{ textAlign: "left", marginBottom: "-20px" }}
                          >
                            확정된 콘텐츠를 화면에 적용해보세요{" "}
                          </H3>
                          <DashedLine />
                          <CompletionContainer>
                            <CompletionIcon>
                              <CheckIcon>
                                <svg
                                  width="28"
                                  height="26"
                                  viewBox="0 0 28 26"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M26.7408 1.07458C27.9568 1.9055 28.269 3.56483 27.438 4.78081L13.7714 24.7808C13.3237 25.4359 12.6076 25.8576 11.8176 25.9314C11.0277 26.0052 10.2458 25.7234 9.68463 25.1625L1.34609 16.8292C0.304367 15.7881 0.30384 14.0997 1.34491 13.0579C2.38599 12.0162 4.07443 12.0157 5.11615 13.0568L11.1813 19.1181L23.0346 1.77179C23.8655 0.555813 25.5249 0.243661 26.7408 1.07458Z"
                                    fill="white"
                                  />
                                </svg>
                              </CheckIcon>
                            </CompletionIcon>

                            <CompletionMessage>
                              <H3
                                color="gray800"
                                style={{
                                  marginBottom: "8px",
                                  marginTop: "16px",
                                }}
                              >
                                콘텐츠 등록이 완료되었습니다
                              </H3>
                            </CompletionMessage>
                          </CompletionContainer>

                          <ContentAnalysisSection>
                            <MoleculeAnalysisCard
                              showButton={false}
                              type="template"
                              onButtonClick={() => {
                                setShowPreviewPopup(true);
                              }}
                              values={{
                                deviceInfo: `${selectedDevice?.deviceTitle} (${selectedDevice?.deviceSpec.deviceInch} / ${selectedDevice?.deviceSpec.deviceWidth}x${selectedDevice?.deviceSpec.deviceHeight} (mm))`,
                                analysisData: autoDisplayFileAnalysis,
                                contentPurpose: selectedPurposes.customerList,
                                designConcept:
                                  selectedDesignConcepts || "concept1",
                              }}
                            />
                          </ContentAnalysisSection>
                          <DashedLine />
                        </TabContent5Item>
                      </div>

                      <ButtonContainer>
                        <Button
                          Primary
                          Large
                          Fill
                          style={{
                            width: "120px",
                            height: "40px",
                            fontSize: "16px",
                          }}
                          onClick={handleGoBack}
                        >
                          돌아가기
                        </Button>
                      </ButtonContainer>
                    </>
                  )}
                </TabContent5>
              )}
          </DesignAnalysisWrap>
        </MainContent>
      </ContentsWrap>

      {showPopupError && (
        <PopupWrap
          Warning
          title="다시 입력해 주세요."
          message="현재 입력하신 정보는 목적을 생성할 수 없습니다."
          buttonType="Outline"
          confirmText="확인"
          isModal={false}
          onConfirm={() => window.location.reload()}
        />
      )}

      {showPopupFileSize && (
        <PopupWrap
          Warning
          title="파일 크기 초과"
          message="파일 크기는 20MB를 초과할 수 없습니다."
          buttonType="Outline"
          confirmText="확인"
          isModal={false}
          onConfirm={() => setShowPopupFileSize(false)}
        />
      )}

      {showCreditPopup && (
        <PopupWrap
          Warning
          title="서비스 이용 안내"
          message="해당 서비스를 이용하시겠습니까?"
          buttonType="Outline"
          closeText="확인"
          isModal={false}
          onCancel={() => {
            setShowCreditPopup(false);
            navigate("/Tool");
          }}
          onConfirm={() => {
            setShowCreditPopup(false);
            navigate("/Tool");
          }}
        />
      )}

      {showPreviewPopup && (
        <>
          <StyledInterviewPopup>
            <div
              style={{
                maxWidth: "700px",
                width: "100%",
                position: "fixed",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                gap: "20px",
                padding: "32px 32px",
                borderRadius: "15px",
                background: "#FFFFFF",
                boxShadow: "4px 4px 30px rgba(0, 0, 0, 0.15)",
              }}
            >
              <div className="header">
                <H4
                  style={{
                    fontSize: "16px",
                    marginBottom: "16px",
                  }}
                >
                  디스플레이 콘텐츠 자세히 보기
                  <span
                    className="close"
                    onClick={() => setShowPreviewPopup(false)}
                  />
                </H4>
              </div>

              <div className="content" style={{ textAlign: "left" }}>
                <div style={{ marginBottom: "12px" }}>
                  <Body2
                    color="gray700"
                    style={{ fontWeight: "400", textAlign: "left" }}
                  >
                    콘텐츠 목적
                  </Body2>
                  <DetailBox>
                    <Body2
                      color="gray800"
                      style={{ fontWeight: "400", textAlign: "left" }}
                    >
                      {selectedPurposes.customerList}
                    </Body2>
                  </DetailBox>
                </div>

                <div>
                  <Body2
                    color="gray700"
                    style={{ fontWeight: "400", textAlign: "left" }}
                  >
                    콘텐츠 내용
                  </Body2>
                  <DetailContentBox>
                    <Body3
                      color="gray600"
                      style={{ fontWeight: "400", textAlign: "left" }}
                    >
                      {autoDisplayFileAnalysis?.detail}
                    </Body3>
                  </DetailContentBox>
                </div>
              </div>
            </div>
          </StyledInterviewPopup>
        </>
      )}
    </>
  );
};

export default PageCreateInfoContent;

const DesignAnalysisWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 100px;
  margin-top: 60px;
`;

const InterviewModeSelection = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
  justify-content: flex-start;
  margin-bottom: 48px;

  button {
    flex: 0 0 auto;
    max-width: 200px;
  }

  .button-container {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    margin-top: 20px;
  }
`;

export const CheckCircle = styled.input`
  appearance: none;
  display: block !important;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  cursor: pointer;

  background-image: ${(props) =>
    props.checked
      ? `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'%3E%3Ccircle cx='12' cy='12' r='12' fill='%23226FFF'/%3E%3Cpath d='M6.76562 12.4155L9.9908 15.6365L17.2338 8.36426' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E")`
      : `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'%3E%3Ccircle cx='12' cy='12' r='11.5' stroke='%23E0E4EB'/%3E%3C/svg%3E")`};
  transition: background-image 0.3s ease-in-out;

  + label {
    cursor: pointer;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;

    + label {
      cursor: not-allowed;
      opacity: 0.5;
    }
  }
`;

const StyledInterviewPopup = styled(InterviewPopup)`
  .markdown-body {
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      margin-top: 0px;
      margin-bottom: 12px;
      color: ${palette.gray800};
      font-weight: 600;
    }
    p,
    li,
    span {
      line-height: 1.55;
    }
    p {
      margin-bottom: 8px;
    }
    h1 {
      font-size: 24px;
    }
    h2 {
      font-size: 20px;
    }
    h3 {
      font-size: 18px;
    }
  }
  .core-value-section h2:nth-of-type(4) ~ p:last-of-type {
    margin-bottom: 12px !important;
  }

  h2:nth-of-type(4) ~ h2:nth-of-type(5) {
    margin-top: 20px;
  }
`;

const InfoBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 20px;
  border: 1px solid ${palette.outlineGray};
  border-radius: 10px;
  // background: ${palette.gray100};
  width: 100%;
`;

const InfoContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const DeviceInfoBox = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  // padding: 12px 16px;
  border-radius: 6px;
  // margin-top: 8px;

  > * {
    white-space: nowrap;
  }

  > *:not(:last-child)::after {
    content: "|";
    margin-left: 8px;
    color: #e0e4eb;
  }
`;

const ContentAnalysisSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  margin: 24px 0 0px 0;
  width: 100%;
`;

const ContentOptionsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const FestivalInfoBox = styled.div`
  border: 1px solid ${palette.outlineGray};
  border-radius: 16px;
  padding: 24px;
  margin-top: 16px;
  min-width: 100%;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
`;

const CompletionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin: 32px auto;
  text-align: center;
  width: 100%;
`;

const CompletionIcon = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: ${palette.primary};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CheckIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const CompletionMessage = styled.div`
  text-align: center;
  max-width: 400px;
`;

const DashedLine = styled.div`
  width: 100%;
  height: 1px;
  border-top: 2px solid ${palette.gray300};
  margin: 0px;
  margin-top: 32px;
  margin-bottom: 36px;
`;

const DetailBox = styled.div`
  background: ${palette.gray100};
  border-radius: 8px;
  padding: 12px 16px;
`;

const DetailContentBox = styled.div`
  background: ${palette.gray100};
  border-radius: 8px;
  padding: 12px 16px;
`;


const TargetAudienceRadioContainer = styled.div`
  width: 100%;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 20px;
  display: flex;
`;

const TargetAudienceSection = styled.div`
  align-self: stretch;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 12px;
  display: flex;
`;

const SectionTitle = styled.span`
  color: #666666;
  font-size: 16px;
  font-family: Pretendard;
  font-weight: 700;
  line-height: 1.55;
  word-wrap: break-word;
  text-align: inherit;
`;

const RadioButtonRow = styled.div`
  align-self: stretch;
  justify-content: flex-start;
  align-items: center;
  gap: 13px;
  display: flex;
  flex-wrap: wrap;
`;

const RadioButtonItem = styled.div`
  width: 195.25px;
  padding: 12px;
  background: ${(props) =>
    props.selected ? "rgba(34, 111, 255, 0.04)" : "white"};
  border-radius: 10px;
  border: 1px solid ${(props) => (props.selected ? "#226FFF" : "#E0E4EB")};
  justify-content: flex-start;
  align-items: center;
  gap: 16px;
  display: flex;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: ${(props) =>
      props.selected ? "rgba(34, 111, 255, 0.04)" : "#F7F8FA"};
    border-color: ${(props) => (props.selected ? "#226FFF" : "#BCC4D0")};
  }
`;

const RadioButtonLabel = styled.label`
  cursor: pointer;
  flex: 1;
`;

const RadioButtonContent = styled.div`
  justify-content: center;
  align-items: center;
  gap: 12px;
  display: flex;
`;

const RadioButtonText = styled.span`
  color: ${(props) => (props.selected ? "#226FFF" : "#666666")};
  font-size: 16px;
  font-family: Pretendard;
  font-weight: 600;
  line-height: 24.8px;
  word-wrap: break-word;
`;

const RadioButtonIcon = styled.div`
  width: 44px;
  height: 44px;
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    width: 36px;
    height: 36px;

    path {
      stroke: ${(props) => (props.selected ? "#226FFF" : "#DEDEDE")};
    }
    rect {
      stroke: ${(props) => (props.selected ? "#226FFF" : "#DEDEDE")};
    }
  }
`;
const Label = styled.label`
  color: #666666;
  font-size: 16px;
  font-family: Pretendard;
  font-weight: 700;
  line-height: 1.55;
  text-align: left;
`;

const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
`;

const ContentInputSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 0px;
  margin-bottom: 24px;
  width: 100%;
`;
